import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { TagModule } from 'primeng/tag';

interface Benefit {
  id: number;
  icon: string;
  title: string;
  description: string;
  badge?: string;
  delay: string;
  color: string;
  gradient: string;
}

@Component({
  selector: 'app-home-benefits',
  templateUrl: './home-benefits.component.html',
  styleUrls: ['./home-benefits.component.scss'],
  imports: [TagModule],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class HomeBenefitsComponent {
  benefits = input<readonly Benefit[]>([]);
}
